import HelpAction from "./HelpAction";
import Legenda from "./Legenda";
import { useState, useEffect } from "react";
import PainelCart from "./PainelCart";
import { limpa, limpaLegenda, valid, download, onCritChange2, onSpecChange2, onSpecBlur2, cparte2, sh2 } from "./Aux.js";


const Cart = (props) => {

    props.setComp('cart');
    document.title = "bqmaps";
    document.querySelector('meta[name="description"]').setAttribute('content','Metro do Porto. Consultar número de cartões diferentes usados por estação. Query number of different cards used at each station.');
    
    const [csv, setCsv] = useState('');
    var specs = {...props.specs};

    // para forçar a actualização da vista, que não ocorre 
    // neste caso devido ao batching de actualizações 
    useEffect( () => { 
        document.getElementById('DMes').value = specs.dmes;
    }, [specs.dmes]);
    
    function cartQuery(e) {
        e.preventDefault();
        limpaLegenda();
        let tipo = props.specs.tipo;
        if (tipo !== '') {
            tipo = tipo.split(" ");
            tipo = limpa(tipo, 1, 7, props.ling, '1');
        }
        specs.tipo = tipo.toString().replace(/,/g, ' ');
        props.setSpecs(specs);
        let ltipo = [];
        for (let i = 0; i < tipo.length; i++) {
            ltipo.push(props.varGlob.dsem[parseInt(tipo[i])]);
        }
        let dmes = props.specs.dmes;
        if (dmes !== '') {
            dmes = dmes.split(" ");
            dmes = limpa(dmes, 1, 31, props.ling, '1');
        }
        specs.dmes = dmes.toString().replace(/,/g, ' ');
        props.setSpecs(specs);
        let anos = props.specs.anos;
        if (anos === '') {
            anos = '2020 2021';
        }
        anos = anos.split(" ");
        anos = limpa(anos, 2020, 2021, props.ling, 2021);
        if( anos.length < 1) {
            anos = ['2020', '2021'];
            alert('Input errado para anos foi substituído. / Wrong input for years was replaced.')
        };
        specs.anos = anos.toString().replace(/,/g, ' ');
        props.setSpecs(specs);
        let meses = props.specs.meses;
        if (meses === '') {
            meses = '1 2 3 4 5 6 7 8 9 10 11 12';
        }
        meses = meses.split(" ");
        meses = limpa(meses, 1, 12, props.ling, 2);
        if( meses.length < 1) {
            meses = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
            alert('Input errado para meses foi substituído. / Wrong input for months was replaced.')
        };
        let lmeses = [];
        for (let i = 0; i < meses.length; i++) {
            lmeses.push(props.varGlob.m[parseInt(meses[i])-1]);
        }
        specs.meses = meses.toString().replace(/,/g, ' ');
        props.setSpecs(specs);
        let mensagem = "Coloridas estações em função (da sma) do ";
        mensagem += "<br>número de cartões diferentes usados<br>";
        mensagem += "<br>No(s) ano(s):      "  + anos; 
        mensagem += "<br>No(s) mes(es) de:     " + lmeses;
        // mensagem += "<br>Na(s) hora(s):     " + horas;
        let filtro = anos + ";" + lmeses + ";"
        if (ltipo.length > 0){
            filtro += ltipo + ";";
            mensagem += "<br>Nos dias tipo:     "  + ltipo; 
        }
        if (dmes.length>0){
            filtro += dmes + ";";
            mensagem += "<br>Nos dias do mês:    "  + dmes;
        }
        const params = {
        "serv": "cart",
        "anost": anos,
        "mesest": meses,
        "tipot": tipo,
        "dmest": dmes
        };
        cartFetchAsync (
            "/bqmapsnode/?params="  + JSON.stringify(params), filtro
        );
    };

    async function cartFetchAsync (url, filtro) {
        let response = await fetch (url, {
            mode: 'no-cors',
            credentials: 'same-origin',
        });
        if (response.ok) {
            let resultados = await response.json();
            if (resultados.length < 1) {
                cartAlertaDados();
                return resultados;
            } else { 
                console.log(resultados);
                let s = {...specs};
                s.res = resultados;
                props.setSpecs(s);
                cartSaveCsv(resultados, filtro);
                return resultados;
            }
        } else {
            console.log(url, response.headers);
            console.log('HTTP ERROR: ' + response.status);
        }
    }

    function cartAlertaDados() {
        if (props.ling === 'pt') {
            alert ('Não há dados para o período especificado! Só de Set 2020 a Fev 2021, inc. (excepto Abr 2020)');
        } else {
            alert ('No data for the specified period! Only for Sep 2020 to Feb 2021, inc. (Apr 2020 excluded)')
        }
    }

    async function cartSaveCsv(resultados, filtro){
        setCsv('');
        let ponto = resultados[0];
        let campo = Object.keys(ponto);
        let nloc = resultados.length;
        let csvCont = "Anos;Meses;Horas;Dias; \n";
        csvCont = csvCont + filtro + "\n \n";
        csvCont = csvCont + "#;Est;Cartões \n";
        for (let i=0; i<nloc; i++){
            let j = resultados[i][campo[0]] - 1;
            csvCont = csvCont + j + ";";
            if (j < 85) {
                csvCont = csvCont + props.varGlob.e[j] + ";";
            }
            csvCont = csvCont + parseInt(resultados[i][campo[3]]) + "\n";
        }
        let response = await fetch ("/bqmapsnode/?fileToWrite=" + encodeURIComponent(csvCont), {
            mode: 'no-cors',
            credentials: 'same-origin',
        })
        let fileName = await response.json();
        console.log (fileName);
        if (!response.ok) {
            console.log(response.headers);
            console.log('HTTP ERROR: ' + response.status);
        }
        setCsv(fileName);
    }

    
    return ( 
        <div className="val">
            <div id="toast"></div>
            <div id="stats">
                <div id="menu">
                    <HelpAction 
                        ling={props.ling} 
                        titPt={"Colorir estações em função do número de cartões usados"}
                        titUk={"To color stations according to the number of cards used"}
                        helpPt={"https://docs.google.com/presentation/d/1Md1rxNPAehqp-fAxkAKCpzVjry5114s6AX3vpyGCCS8/edit?usp=share_link"}
                        helpUk={"https://docs.google.com/presentation/d/1Q645i2zWkdipw9AKb6LBVEgv6fLks5eEcCePcufzuQY/edit?usp=share_link"}
                        varGlob={props.varGlob}
                        onSpecChange2={onSpecChange2}
                        specs={specs}
                        setSpecs={props.setSpecs}
                        query={cartQuery}
                        csv={csv}
                        download={download} />
                    <PainelCart
                        ling={props.ling}
                        specs={specs}
                        setSpecs={props.setSpecs}
                        setComp={props.setComp}
                        valid={valid}
                        onCritChange2={onCritChange2}
                        sh2={sh2}
                        onSpecChange2={onSpecChange2}
                        onSpecBlur2={onSpecBlur2}
                        cparte2={cparte2}
                        varGlob={props.varGlob}  />
                    <Legenda />
                </div>   
            </div>
        </div>
    );
    }


export default Cart;